import React from 'react';

import FitmentTireSizeOeDropdownOptionDetails from './components/fitment-tire-size-oe-dropdown-option-details';
import {
  CANT_FIND_OPTION_IDS,
  OPTIONAL_TIRE_SIZE_ID
} from '../../../../fitment-constants';
import { splitStaggeredTireDescriptions } from '../../fitment-by-vehicle-util';

import { isArrayWithLength } from '../../../../../../shared/utils/validators/validators';

import { OptionValue } from '../../../../../../shared/types/select';

import './fitment-tire-size-oe-dropdown-option.scss';

interface FitmentTireSizeOeDropdownOptionProps extends OptionValue {
  className?: string;
  isFocused: boolean;
  isOption?: boolean;
  isSelected: boolean;
}

function FitmentTireSizeOeDropdownOption(
  props: FitmentTireSizeOeDropdownOptionProps
) {
  const {
    className = '',
    isFocused,
    isOption = false,
    isSelected,
    label,
    value
  } = props;
  const isSize =
    value !== CANT_FIND_OPTION_IDS.SIZE && value !== OPTIONAL_TIRE_SIZE_ID;
  const tireDescriptions = splitStaggeredTireDescriptions(label);
  const isStaggered = isArrayWithLength(tireDescriptions);

  return (
    <div
      aria-selected={isSelected}
      className={`fitment-tire-size-oe-dropdown-option ${className}`}
      role="option"
      styleName={`container${
        isStaggered && isOption ? ' container--staggered' : ''
      }${isFocused ? ' container--focused' : ''}${
        isSelected ? ' container--selected' : ''
      }`}
    >
      <FitmentTireSizeOeDropdownOptionDetails
        isSize={isSize}
        isStaggered={isStaggered}
        label={label}
        tireDescriptions={tireDescriptions}
      />
    </div>
  );
}

export default FitmentTireSizeOeDropdownOption;
